import * as React from 'react';
import type {ReactNode} from 'react';
import {SelectMenu} from '../SelectMenu';
import type {MenuListProps} from './types';
import type {SelectValue} from '../types';

function DefaultMenuList<T, V extends SelectValue, L extends ReactNode>(
  props: MenuListProps<T, V, L>,
) {
  const {
    id,
    labelledBy,
    describedBy,
    getOptionId,
    options,
    selectedOptions,
    isMulti,
    highlightedIndex,
    onOptionHover,
    onOptionClick,
    disabled,
    isOptionDisabled,
    menuLoading,
    listRef,
    registerOptionRef,
    menuClassName,
    noOptionsMessage,
    emptyContent,
    footer,
    components,
    inputValue,
    formatOptionLabel,
    isOptionSelected,
    onMenuScrollToBottom,
    groupedOptions,
    formatGroupLabel,
  } = props;

  return (
    <SelectMenu
      id={id}
      options={options}
      labelledBy={labelledBy}
      describedBy={describedBy}
      selectedValue={!isMulti ? (selectedOptions[0] ?? null) : undefined}
      selectedValues={isMulti ? selectedOptions : undefined}
      highlightedIndex={highlightedIndex}
      onOptionClick={onOptionClick}
      onOptionHover={onOptionHover}
      disabled={disabled}
      isOptionDisabled={isOptionDisabled}
      menuLoading={menuLoading}
      menuClassName={menuClassName}
      listRef={listRef}
      selectedOptionRef={registerOptionRef}
      getOptionId={getOptionId}
      noOptionsMessage={noOptionsMessage}
      isMulti={isMulti}
      emptyContent={emptyContent}
      footer={footer}
      components={components}
      inputValue={inputValue}
      formatOptionLabel={formatOptionLabel}
      isOptionSelected={isOptionSelected}
      onMenuScrollToBottom={onMenuScrollToBottom}
      groupedOptions={groupedOptions}
      formatGroupLabel={formatGroupLabel}
    />
  );
}

export {DefaultMenuList};
